// extracted by mini-css-extract-plugin
export default {"text":"TrainerNotePage_text__d28a5"};